import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-slate-950 px-4 py-5 text-center md:px-12" data-id="element-77" data-mp="3gfiugihumbe4">
      <p className="text-[11px] font-extrabold uppercase text-white" data-id="element-78" data-mp="32nulgo2wc31d">
        © 2026 Bright Digital Hub — All Rights Reserved.
      </p>
      <div className="mx-auto mt-1.5 max-w-[640px] space-y-1 text-[12px] leading-[1.4] text-white/70" data-id="element-79" data-mp="36qhgexuv642s">
        <p data-id="element-80" data-mp="3ug3fllb8kjas">
          Pediatric OT Complete Therapy System™ provides educational reference materials and practical professional
          resources for pediatric occupational therapy. It does not replace accredited occupational therapy training,
          individualized assessment, independent clinical judgment, applicable medical guidance, institutional safety
          procedures, or professional licensing requirements.
        </p>
        <p data-id="element-81" data-mp="2a19vns22jyzx">
          Activities must be selected and adapted according to each child's functional abilities, communication needs,
          preferences, medical considerations, safety requirements, and participation goals. Included observation forms
          and decision maps are original educational tools, not standardized assessments or validated diagnostic
          instruments.
        </p>
        <p data-id="element-82" data-mp="3v5n74ggw1hz6">
          All clinical content should undergo independent review by qualified pediatric occupational therapy
          professionals before distribution for clinical use.
        </p>
      </div>
      <nav aria-label="Legal" className="mt-1.5 text-[12px] text-white" data-id="element-83" data-mp="80nrednpyga8">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-84" data-mp="hstsccvy881k" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-85" data-mp="hsabz0ly5rpn">•</span>}
            <a href={l.href} className="transition-colors duration-150 hover:text-amber-400" data-id="element-86" data-mp="cu0cidt6w4y8">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1 text-[12px] text-white" data-id="element-87" data-mp="mrwplb5ot9yz">
        Customer Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline transition-colors duration-150 hover:text-amber-400" data-id="element-88" data-mp="mptqm1mk46i4">
          {SUPPORT_EMAIL}
        </a>
      </p>
      <p className="mt-1 text-[12px] text-white/70" data-id="element-89" data-mp="yuzd62ha5noh">Brand: Bright Digital Hub</p>
    </footer>;
}